export default function PayRollOverView({ basic, personal }) {
    return (
        <>
            <div className="border rounded p-2 rs:p-4">
                <div className="flex justify-between items-center mb-3">
                    <h3 className="font-semibold text-[15px] sm:text-[20px]">Basic Information</h3>
                </div>
                <div className="grid grid-cols-1 custom:grid-cols-2 gap-y-2 gap-x-4 text-gray-700 text-[12px] sm:text-[14px]">
                    <p>
                        <span className="font-medium">Name:</span> {basic.name}
                    </p>
                    <p>
                        <span className="font-medium">Work Location:</span> {basic.workLocation}
                    </p>
                    <p>
                        <span className="font-medium">Email Address:</span> {basic.email}
                    </p>
                    <p>
                        <span className="font-medium">Designation:</span> {basic.designation}
                    </p>
                    <p>
                        <span className="font-medium">Mobile Number:</span> {basic.mobile}
                    </p>
                    <p>
                        <span className="font-medium">Department:</span> {basic.department}
                    </p>
                    <p>
                        <span className="font-medium">Date of Joining:</span> {basic.dateOfJoining}
                    </p>

                    <p>
                        <span className="font-medium">Gender:</span> {basic.gender}
                    </p>
                </div>
            </div>
            <div className="border rounded p-4">
                <div className="flex justify-between items-center mb-3">
                    <h3 className="font-semibold text-[15px] sm:text-[20px]">Personal Information</h3>
                </div>
                <div className="grid grid-cols-1 custom:grid-cols-2 gap-y-2 gap-x-4 text-gray-700 text-[12px] sm:text-[14px]">
                    <p>
                        <span className="font-medium">Date of Birth:</span> {personal.dob}
                    </p>
                    <p>
                        <span className="font-medium">Email Address:</span> {personal.email}
                    </p>
                    <p>
                        <span className="font-medium">Father's Name:</span> {personal.fatherName}
                    </p>
                    <p>
                        <span className="font-medium">Residential Address:</span> {personal.address}
                    </p>
                    <p>
                        <span className="font-medium">PAN:</span> {personal.pan}
                    </p>

                </div>
            </div>
        </>
    )
}
